
import React from "react";
export const PopupfaqItems = [
    {
      id: "donation-secure",
      question: "Is my donation secure?",
      answer: (
        <div>
          <p>
            Yes, we use industry-standard SSL technology to keep your information secure
          </p>
          <p>
            We partner with Stripe, the industry's most established payment processor trusted by some of the world's
            largest companies.
          </p>
          <p>
            Your sensitive financial information never touches our servers. We send all data directly to Stripe's
            PCI-compliant servers through SSL.
          </p>
        </div>
      ),
    },
    {
      id: "donation-tax-deductible",
      question: "Is this donation tax-deductible?",
      answer: (
        <div>
          <p>
          We are an organization eligible to receive tax deductible contributions. Your gift may be tax-deductible to the extent allowed by law. Please consult your tax advisor for guidance applicable to your specific situation.
          </p>
          <p>
          We will email you a donation receipt. Please retain it for your records, as it may be required to substantiate your charitable contribution for tax purposes, subject to applicable law.
          </p>
        </div>
      ),
    },
    {
      id: "cancel-recurring",
      question: "Can I cancel my recurring donation?",
      answer: (
        <div>
          <p>
          Of course. You always remain in full control of your recurring donation, and you’re free to change or cancel it at any time.
          </p>
          
        </div>
      ),
    },
    
  ]